(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hp-delivery-email-capture"]) return;
  try {
    
(() => {
  'use strict';
  const marker = document.querySelector('[data-hp-delivery-capture]');
  if (!marker || window.HogpartsDeliveryCapture) return;
  const root = window.Shopify?.routes?.root || '/';
  const prefix = '_hp_delivery_';
  const endpoint = `${root}apps/hogparts-delivery/estimate`;
  const fetchOriginal = window.fetch.bind(window);
  const busyForms = new WeakSet();
  const replayForms = new WeakSet();
  let timer;
  let warmPromise = null;
  let lastSaved = '';
  let lastSavedAt = 0;
  let checkoutBusy = false;
  let serverOffset = 0;
  const now = () => Date.now() + serverOffset;
  const ukDay = (time = now()) => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date(time)).map(part => [part.type, part.value]));
    return `${parts.year}-${parts.month}-${parts.day}`;
  };
  const validDate = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value))) return false;
    const parsed = new Date(`${value}T12:00:00Z`);
    return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
  };
  const physical = cart => (cart.items || []).filter(item => item.requires_shipping && item.quantity > 0);
  const signature = cart => physical(cart).map(item => `${item.variant_id}:${item.quantity}`).sort().join('|');
  const formatRange = (start, end) => {
    const format = (value, options) => new Intl.DateTimeFormat('en-GB', { ...options, timeZone: 'UTC' })
      .format(new Date(`${value}T12:00:00Z`));
    if (start === end) return format(end, { day: 'numeric', month: 'long', year: 'numeric' });
    const sameMonth = start.slice(0, 7) === end.slice(0, 7);
    const sameYear = start.slice(0, 4) === end.slice(0, 4);
    return `${format(start, sameMonth ? { day: 'numeric' } : sameYear ? { day: 'numeric', month: 'long' } : { day: 'numeric', month: 'long', year: 'numeric' })} to ${format(end, { day: 'numeric', month: 'long', year: 'numeric' })}`;
  };
  const emptySnapshot = (cart = { items: [] }) => ({
    [`${prefix}version`]: '1', [`${prefix}status`]: 'unavailable',
    [`${prefix}scope`]: 'UK', [`${prefix}signature`]: signature(cart),
    [`${prefix}earliest`]: '', [`${prefix}latest`]: '',
    [`${prefix}checked_at`]: '', [`${prefix}checked_on`]: '',
    'Hogparts estimated delivery': ''
  });
  async function json(url, options = {}, signal) {
    const response = await fetchOriginal(url, { ...options, signal, credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(options.headers || {}) } });
    if (!response.ok) throw new Error('Delivery capture request failed');
    const serverDate = Date.parse(response.headers.get('Date') || '');
    if (Number.isFinite(serverDate)) serverOffset = serverDate - Date.now();
    return response.json();
  }
  function submittedCart(cart, form) {
    if (!form) return cart;
    const rows = Array.from(form.querySelectorAll('[data-cartitem-key]'));
    return { ...cart, items: cart.items.map(item => {
      const row = rows.find(candidate => candidate.dataset.cartitemKey === item.key);
      const input = row?.querySelector('[name="updates[]"], [name^="updates["]');
      if (!input) return item;
      const quantity = Number(input.value);
      if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 9999) throw new Error('Invalid requested quantity');
      return { ...item, quantity };
    }).filter(item => item.quantity > 0) };
  }
  async function makeSnapshot(cart, signal) {
    const result = emptySnapshot(cart);
    const groups = new Map();
    for (const item of physical(cart)) {
      const id = String(item.variant_id);
      if (!/^\d+$/.test(id)) return result;
      groups.set(id, (groups.get(id) || 0) + item.quantity);
    }
    if (!groups.size || groups.size > 50) return result;
    const entries = [...groups.entries()];
    const estimates = [];
    for (let index = 0; index < entries.length; index += 5) {
      const batch = await Promise.all(entries.slice(index, index + 5).map(async ([id, quantity]) => {
        if (quantity > 9999) return null;
        const data = await json(`${endpoint}?variant_id=${encodeURIComponent(id)}&quantity=${quantity}`, {}, signal);
        if (data.available !== true || !validDate(data.earliest) || !validDate(data.latest)
          || data.earliest > data.latest || data.earliest < ukDay()) return null;
        return data;
      }));
      if (batch.some(value => !value)) return result;
      estimates.push(...batch);
    }
    const earliest = estimates.map(item => item.earliest).sort().at(-1);
    const latest = estimates.map(item => item.latest).sort().at(-1);
    return { ...result, [`${prefix}status`]: 'ready', [`${prefix}earliest`]: earliest,
      [`${prefix}latest`]: latest, [`${prefix}checked_at`]: String(Math.floor(now() / 1000)),
      [`${prefix}checked_on`]: ukDay(), 'Hogparts estimated delivery': formatRange(earliest, latest) };
  }
  async function calculate(form = null, persist = false) {
    const controller = new AbortController();
    const deadline = setTimeout(() => controller.abort(), 7000);
    let cart = { items: [], attributes: {} };
    try {
      for (let attempt = 0; attempt < 2; attempt += 1) {
        cart = await json(`${root}cart.js`, { cache: 'no-store' }, controller.signal);
        const intended = submittedCart(cart, form);
        const stamp = `${signature(intended)}:${ukDay()}`;
        if (persist && stamp === lastSaved && now() - lastSavedAt < 45000) return null;
        if (persist && !physical(cart).length && !cart.attributes?.[`${prefix}version`]) return null;
        const snapshot = await makeSnapshot(intended, controller.signal);
        const current = await json(`${root}cart.js`, { cache: 'no-store' }, controller.signal);
        if (signature(current) !== signature(cart) || signature(submittedCart(current, form)) !== signature(intended)) continue;
        if (persist) {
          if (checkoutBusy) return null;
          const saved = await json(`${root}cart/update.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { ...current.attributes, ...snapshot } })
          }, controller.signal);
          if (signature(saved) !== signature(current)) { lastSaved = ''; return null; }
          lastSaved = stamp;
          lastSavedAt = now();
        }
        return snapshot;
      }
      return emptySnapshot(cart);
    } catch (_) {
      if (persist && !checkoutBusy && !controller.signal.aborted) {
        try {
          await json(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { ...cart.attributes, ...emptySnapshot(cart) } }) }, controller.signal);
        } catch (_) {}
      }
      return emptySnapshot(cart);
    } finally { clearTimeout(deadline); }
  }
  function fillForm(form, attributes) {
    form.querySelectorAll('[data-hp-delivery-field]').forEach(input => input.remove());
    for (const [key, value] of Object.entries(attributes)) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = `attributes[${key}]`; input.value = value;
      input.dataset.hpDeliveryField = 'true'; form.append(input);
    }
  }
  function warm() {
    if (checkoutBusy || document.hidden) return;
    if (!warmPromise) warmPromise = calculate(null, true).finally(() => { warmPromise = null; });
    return warmPromise;
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(warm, 450); }
  function isCartForm(form) {
    try { return new URL(form.action, location.href).pathname.replace(/\/$/, '') === `${root}cart`.replace(/\/$/, ''); }
    catch (_) { return false; }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isCartForm(form)) return;
    if (replayForms.has(form)) return;
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busyForms.has(form)) return;
    busyForms.add(form); checkoutBusy = true;
    const oldBusy = form.getAttribute('aria-busy'); form.setAttribute('aria-busy', 'true');
    Promise.resolve(warmPromise).catch(() => {}).then(() => calculate(form, false)).then(snapshot => {
      fillForm(form, snapshot || emptySnapshot());
    }).catch(() => fillForm(form, emptySnapshot())).finally(() => {
      busyForms.delete(form); checkoutBusy = false;
      if (oldBusy === null) form.removeAttribute('aria-busy'); else form.setAttribute('aria-busy', oldBusy);
      if (!form.isConnected) return;
      replayForms.add(form);
      try { HTMLFormElement.prototype.requestSubmit.call(form, submitter); }
      finally { replayForms.delete(form); }
    });
  }, true);
  const watched = '[data-cartitem], [data-cart-total], [data-atc-banner-cart-subtotal], [data-atc-banner-cart-button], .cart-count, .cart-drawer';
  new MutationObserver(records => {
    if (records.some(record => record.target instanceof Element
      && (record.target.matches(watched) || record.target.closest(watched)
        || [...record.addedNodes].some(node => node instanceof Element && (node.matches(watched) || node.querySelector(watched)))))) schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:build', 'shopify:section:load'].forEach(name => document.addEventListener(name, schedule));
  document.addEventListener('change', event => { if (event.target.matches('[name^="updates["]')) schedule(); });
  document.addEventListener('submit', event => { if (event.target.matches('form[action*="/cart/add"]')) { schedule(); setTimeout(schedule, 1600); } });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  window.HogpartsDeliveryCapture = Object.freeze({ version: '1.0.0-draft', refresh: warm });
  schedule();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-home-model-family"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.hpReady === 'true') return;
    root.dataset.hpReady = 'true';
    var grid = root.querySelector('.hp-model-grid');
    var items = Array.from(grid.querySelectorAll(':scope > .hp-model-grid__item'));
    var cards = Array.from(root.querySelectorAll('[data-hp-family-card]'));
    var row = root.querySelector('.hp-model-panel-row');
    var panels = Array.from(row.querySelectorAll('.hp-family-panel'));
    var selected = null;
    function place() {
      if (!selected) return;
      // Measure actual rows, including the full-width last card on mobile.
      var item = selected.closest('.hp-model-grid__item');
      row.hidden = true;
      var top = item.getBoundingClientRect().top;
      var last = item;
      items.forEach(function (candidate) {
        if (Math.abs(candidate.getBoundingClientRect().top - top) < 2) last = candidate;
      });
      last.after(row);
      row.hidden = false;
    }
    function close(restoreFocus) {
      var previous = selected;
      cards.forEach(function (card) { card.setAttribute('aria-expanded', 'false'); });
      panels.forEach(function (panel) { panel.hidden = true; });
      row.hidden = true;
      selected = null;
      if (restoreFocus && previous) previous.focus({preventScroll: true});
    }
    function open(card) {
      if (selected === card) { close(false); return; }
      close(false);
      var panel = document.getElementById(card.dataset.hpPanel);
      if (!panel) return;
      selected = card;
      card.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      place();
    }
    cards.forEach(function (card) {
      card.setAttribute('role', 'button');
      card.setAttribute('aria-expanded', 'false');
      card.setAttribute('aria-controls', card.dataset.hpPanel);
      card.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        open(card);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key === ' ') { event.preventDefault(); open(card); }
      });
    });
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-hp-family-close]')) close(true);
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && selected) { event.preventDefault(); close(true); }
    });
    var frame = 0;
    window.addEventListener('resize', function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () { frame = 0; place(); });
    }, {passive: true});
  }
  function load() { document.querySelectorAll('[data-hp-family-browser]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
  document.addEventListener('shopify:section:load', load);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return;
    }

    event.preventDefault();

    try {
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');

      const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
        atcButton: submitButton,
        settings: { moneyFormat: window.SHOP_MONEY_FORMAT }
      });

      const handleComplete = (completeEvent) => {
        document.removeEventListener('addToCartFlyout:complete', handleComplete);
        document.removeEventListener('addToCartFlyout:error', handleError);
        event.detail.resolve(completeEvent.detail.responseData);
      };

      const handleError = (errorEvent) => {
        document.removeEventListener('addToCartFlyout:complete', handleComplete);
        document.removeEventListener('addToCartFlyout:error', handleError);
        event.detail.reject(errorEvent.detail.error);
      };

      document.addEventListener('addToCartFlyout:complete', handleComplete);
      document.addEventListener('addToCartFlyout:error', handleError);
    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
